import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ErrorBox extends Component {
  render() {
    const cause = this.props.error.cause;

    if(cause === undefined) {
      return <h1>{this.props.error.toString()}</h1>;
    }

    return (
      <div className="container">
        {cause && cause.status && cause.title &&
          <h1>{`${cause.status} ${cause.title}`}</h1>
        }
        {cause && cause.detail &&
          <h3>{cause.detail}</h3>
        }
      </div>
    );
  }
}

ErrorBox.propTypes = {
  error: PropTypes.object,
  meta: PropTypes.array,
};

export default ErrorBox;



// WEBPACK FOOTER //
// ./src/components/apiAccess/ErrorBox.js